var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"parallax-glider",style:({ backgroundImage: 'url(' + _vm.imgurl + ')' }),attrs:{"id":_vm.sectionID}})
}
var staticRenderFns = []

export { render, staticRenderFns }